import useAxios from "axios-hooks";
import { useEffect } from "react";

import config from "@/messenger/config";

interface TUseVerifyMessageProps {
    content: string;
    conversationId: string;
    shouldVerify: boolean;
}

export const useVerifyMessage = ({ content, conversationId, shouldVerify }: TUseVerifyMessageProps) => {
    const [{ data, error, loading }, touchlessVerify] = useAxios({
        url: config.api.touchlessVerify,
        method: "POST",
    }, { manual: true });

    useEffect(() => {
        if (content && shouldVerify) {
            touchlessVerify({
                data: {
                    query: `
                        query verifyMessage {
                            verifyMessage(
                                input: {
                                    content: "${content?.replace(/"/g, '\\"')}", 
                                }
                            ) 
                            {
                                complianceAdvices {
                                    adviceAction
                                    complianceRule
                                    content
                                    contentArea {
                                        start
                                        end
                                    }
                                    reasonCode
                                    reasonDescription
                                    reasonMessage
                                }
                                content
                                originalContent
                            }
                        }
                    `,
                },
            });
        }
    }, [shouldVerify]);

    return { data: data?.data ?? undefined, error, loading };
};
